import React from 'react';
import { Card, Descriptions, Table } from 'antd';
import type { TableProps } from 'antd';
import EnumKeyToText from './enumkeyTotext';

interface EventTypePropsType {
	data?: any;
	enums?: any;
}

const EventType: React.FC<EventTypePropsType> = props => {
	const { data, enums } = props;

	return <EnumKeyToText data={data} enums={enums} valueKey={'event_type'} nameSpace={'deposit_event_type'} />;
};

interface EventStatusPropsType {
	data?: any;
	enums?: any;
}

const EventStatus: React.FC<EventStatusPropsType> = props => {
	const { data, enums } = props;

	return (
		<>
			<EnumKeyToText data={data} enums={enums} valueKey={'event_type'} nameSpace={'deposit_event_type'} />
			<EnumKeyToText data={data} enums={enums} valueKey={'event_status'} nameSpace={'deposit_event_status'} />
		</>
	);
};

interface PropsType {
	enums?: any;
	data?: any;
	changePriceFormat?: any;
}

interface TableDataType {
	id: number;
	username?: string;
	cell_encrypt?: string;
	user_status?: number;
	role_list?: any;
	store_list?: any;
	create_time?: string;
	update_time?: string;
}

const DepositDetails: React.FC<PropsType> = props => {
	const { data, enums, changePriceFormat } = props;

	const colorStyle: React.CSSProperties = { color: '#fc9c4b' };

	const columns: TableProps<TableDataType>['columns'] = [
		{ title: '操作时间', dataIndex: 'operate_time', key: 'operate_time' },
		{
			title: '类型',
			dataIndex: 'event_type',
			key: 'event_type',
			render: (_, record) => <EventType data={record} enums={enums} />,
		},
		{
			title: '金额',
			dataIndex: 'amount',
			key: 'amount',
			render: text => changePriceFormat(text),
		},
		{
			title: '状态',
			dataIndex: 'event_status',
			key: 'event_status',
			render: (_, record) => <EventStatus data={record} enums={enums} />,
		},
		{
			title: '操作人',
			dataIndex: 'operator',
			key: 'operator',
		},
	];

	return (
		<Card title="押金明细" style={{ marginTop: '20px' }}>
			<Descriptions column={4}>
				<Descriptions.Item label="车损押金">¥{changePriceFormat(data?.broken_amount)}</Descriptions.Item>
				<Descriptions.Item label="违章押金">¥{changePriceFormat(data?.illegal_amount)}</Descriptions.Item>
				<Descriptions.Item label="已冻结押金">¥{data?.authorize_status === 1 ? changePriceFormat(data?.freeze_amount) : 0}</Descriptions.Item>
				<Descriptions.Item label="已解冻押金">¥{changePriceFormat(data?.unfreeze_amount)}</Descriptions.Item>
				<Descriptions.Item label="是否授权免押">
					<span style={colorStyle}>{data?.authorize_status === 1 ? '已授权' : '未授权'}</span>
				</Descriptions.Item>
				<Descriptions.Item label="冻结状态">
					<span style={colorStyle}>
						{
							<EnumKeyToText
								data={data}
								enums={enums}
								valueKey={'deposit_status'}
								nameSpace={'deposit_status'}
							/>
						}
					</span>
				</Descriptions.Item>
				<Descriptions.Item label="预计解冻时间">{data?.pre_unfreeze_time || '--'}</Descriptions.Item>
			</Descriptions>
			<Table columns={columns} dataSource={data?.event_items} rowKey={cols => cols.id} pagination={false} />
		</Card>
	);
};

export default DepositDetails;
